/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import * as Sentry from '@sentry/browser';
import { redirectToLogin } from '@olxeu-a2b/delivery-utils/src/extras';
import { useViewport } from '@olxeu-a2b/delivery-utils/src/hooks';

export default memo(({ name, isPublic, ...args }) => {
  const [cookies] = useCookies(['access_token']);
  const { desktop } = useViewport();

  useEffect(() => {
    Sentry.configureScope(scope => scope.setTag('page', name));
  }, [name]);

  // --------- Terser will remove this entire block on production builds --------- //
  if (process.env.NODE_ENV === 'development') {
    if (!cookies.access_token) {
      const BondDevLogin = React.lazy(() => import('@olxeu-a2b/delivery-utils/src/dev'));
      return (
        <>
          <BondDevLogin />
          <Route {...args} />
        </>
      );
    }
  }
  // ----------------------------------------------------------------------------- //
  if (isPublic || cookies.access_token) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Route {...args} />;
  }

  redirectToLogin(desktop);
  return null;
});
